"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputSchema = exports.default = void 0;
var TextInput_1 = require("./TextInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(TextInput_1).default; } });
Object.defineProperty(exports, "TextInputSchema", { enumerable: true, get: function () { return TextInput_1.TextInputSchema; } });
//# sourceMappingURL=index.js.map